import type { VellumAuthMeResponse } from "@vellum/vellum-api";

/** Region Admin or above sees the management views. */
export function isPayrollMgmt(user: VellumAuthMeResponse | null): boolean {
  return user?.role === "Admin" || user?.role === "Region Admin";
}
